"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const menu = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-menu` : '') + (description ? ` desc-menu` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-menu"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-menu"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M1 21C0.447716 21 0 21.4477 0 22C0 22.4632 0.316656 22.8586 0.766357 22.9706L0.881449 22.9926L1 23H14C14.5523 23 15 22.5523 15 22C15 21.5368 14.6833 21.1414 14.2336 21.0294L14.1186 21.0074L14 21H1ZM1 11C0.447716 11 0 11.4477 0 12C0 12.4632 0.316656 12.8586 0.766357 12.9706L0.881449 12.9926L1 13H19C19.5523 13 20 12.5523 20 12C20 11.5368 19.6833 11.1414 19.2336 11.0294L19.1186 11.0074L19 11H1ZM1 1C0.447716 1 0 1.44772 0 2C0 2.46322 0.316656 2.85858 0.766357 2.97061L0.881449 2.99259L1 3H23C23.5523 3 24 2.55228 24 2C24 1.53678 23.6833 1.14142 23.2336 1.02939L23.1186 1.00741L23 1H1Z",
    fill: "inherit"
  }));
};
var _default = exports.default = menu;